<template>
  <div id="contenedor-main-contrato-avance-real">
    <template
      v-if="$apollo.loading">
      <!-- Loader -->
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody"
      ></v-skeleton-loader>
    </template>
    <template
      v-else>
      <informacion
        :id-contrato="idContrato"
        :catalogo="listado"
        :estimaciones="getEstimaciones">
      </informacion>
      <v-divider></v-divider>
      <!-- Filtros -->
      <filtros
        :id-contrato="idContrato"
        :filtros="filtros">
      </filtros>
      <v-row
        class="text-subtitle-2">
        <v-col
          cols="1">
          <span>Clave</span>
        </v-col>
        <v-col
          cols="3">
          <span>Concepto</span>
        </v-col>
        <v-col
          cols="1">
          <span>Unidad</span>
        </v-col>
        <v-col
          cols="1"
          class="text-right">
          <span>P. Unitario</span>
        </v-col>
        <v-col
          cols="1">
          <span>Contratado</span>
        </v-col>
        <v-col cols="1">Acumulado</v-col>
        <v-col cols="1">Disponible</v-col>
        <v-col>Parcial</v-col>
        <v-col cols="1">Físco (A + P)</v-col>
      </v-row>
      <v-divider></v-divider>
      <template
        v-for="concepto in listado">
        <template>
          <template
            v-if="concepto.tipo === 2">
            <v-row
              :key="concepto.id"
              :class="getRowClasses(concepto.nivel)">
              <v-col
                cols="1">
                {{ concepto.concepto.clave }}
              </v-col>
              <v-col
                cols="3">
                <cortar-textos
                  :texto="concepto.nombreCorto">
                </cortar-textos>
              </v-col>
              <v-col
                cols="1">
                {{ concepto.concepto.unidad }}
              </v-col>
              <v-col
                cols="1"
                class="text-right">
                {{ concepto.concepto.precioUnitario | currency }}
              </v-col>
              <v-col
                cols="1">
                <template
                  v-if="concepto.tipo === 2">
                  <v-chip
                    class="font-weight-bold"
                    color="bkground">
                    {{ concepto.concepto.cantidad }}
                  </v-chip>
                </template>
              </v-col>
              <v-col
                cols="1">
                <template
                  v-if="concepto.ultimaEstimacion">
                  <v-chip
                    class="font-weight-bold"
                    color="bkground">
                    {{ concepto.ultimaEstimacion.cantidad }}
                  </v-chip>
                </template>
                <template
                  v-else>
                  <v-chip
                    class="font-weight-bold"
                    color="bkground">
                    0
                  </v-chip>
                </template>
              </v-col>
              <v-col
                cols="1">
                <template>
                  <v-chip
                    class="font-weight-bold"
                    :color="concepto.disponible >= 0 ? 'verde1' : 'warning'">
                    {{ concepto.disponible }}
                  </v-chip>
                </template>
              </v-col>
              <v-col>
                <template
                  v-if="concepto.tipo === 2">
                  <registrar-avance-real
                    :id-contrato="idContrato"
                    :concepto="concepto"
                    :cantidad="setCantidad(concepto)"
                    :fecha="fechaAvanceFisico"
                    es-listado>
                  </registrar-avance-real>
                </template>
              </v-col>
              <v-col
                cols="1"
                class="text-right">
                <v-chip
                  color="info">
                  {{ concepto.avance || 0 }}
                </v-chip>
              </v-col>
            </v-row>
          </template>
          <template
            v-else>
            <v-row
              :key="concepto.id"
              :class="getRowClasses(concepto.nivel)">
              <v-col
                cols="1">
                {{ concepto.concepto.clave }}
              </v-col>
              <v-col
                cols="11">
                {{ concepto.concepto.concepto }}
              </v-col>
            </v-row>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import Informacion from './Informacion.vue';
import cortarTextos from '@/components/CortarTextos.vue';
import RegistrarAvanceReal from './Agregar.vue';
import Filtros from './Filtros.vue';
import mixContratoAvanceReal from './mixContratoAvanceReal';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainContratoAvanceReal',
  mixins: [mixContratoAvanceReal],
  components: {
    Informacion,
    cortarTextos,
    Filtros,
    RegistrarAvanceReal,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fechaAvanceFisico: new Date().toISOString().substr(0, 10),
      filtros: {
        buscarTexto: '',
      },
    };
  },
  mounted() {
    eventBus.$on('cambio-fecha-avance-fisico', (fecha) => {
      this.fechaAvanceFisico = fecha;
      this.fechaAv = fecha;
    });
  },
  methods: {
    setCantidad(concepto) {
      if (concepto.ultimoAvanceReal) return concepto.ultimoAvanceReal.cantidad;
      return 0;
    },
    getRowClasses(tipo) {
      switch (tipo) {
        case 1: return 'base4 font-weight-bold primary--text';
        case 2: return 'amber darken-1 white--text';
        case 3: return 'amber lighten-2';
        default: return '';
      }
    },
  },
  computed: {
    listado() {
      if (!this.getConceptosFavoritos) return [];
      return this.getConceptosFavoritos
        .filter((concepto) => {
          if (!this.filtros.buscarTexto) return concepto;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const clave = this.$normalizacionTexto(concepto.concepto.clave);
          const conceptoNormalizado = this.$normalizacionTexto(concepto.nombreCorto);

          return (
            expt.test(clave)
            || expt.test(conceptoNormalizado)
            || expt.test(concepto.concepto.clave)
            || expt.test(concepto.nombreCorto)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
